// extracted by mini-css-extract-plugin
export default {"completeOnboardingContainer":"styles_completeOnboardingContainer__slCTr"};